import { render, staticRenderFns } from "./FspAcknowledgeFormLongevityView.vue?vue&type=template&id=1a53b3ec&"
import script from "./FspAcknowledgeFormLongevityView.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormLongevityView.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormLongevityView.vue?vue&type=style&index=0&id=1a53b3ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports